import {
    Badge,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Grid,
    IconButton,
    makeStyles, TableContainer,
    Typography
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ImageIcon from "@material-ui/icons/Image";
import CommentIcon from "@material-ui/icons/Comment";
import {ArrayField, Button, Datagrid, DeleteButton, FunctionField, TextField, useNotify} from "react-admin";
import React from "react";
import {AddDeliveryAttachmentButton} from "./AddDeliveryAttachmentButton";
import {IdentifierField} from "../../components/IdentifierField";
import {initField} from "../../shared/utils";
import {CustomFileField} from "../../components/CustomFIleField";
import {useOptions} from "../../shared/hooks/useOptions";
import {url as API_URL} from "../../constants";
import {clientNoJson} from "../../dataProvider";

const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "webp", "tif", "tiff"];

export function DeliveryAttachmentImages({record}: { record: any }) {
    const notify = useNotify();
    const attachments = (record?.deliveryattachment_set || []).filter((attachment: any) => {
        const name = attachment?.file_info?.name || "";
        return IMAGE_EXTENSIONS.includes(name.split(".").pop()?.toLowerCase() || "");
    });
    if (!attachments.length) return null;

    const openImage = async (event: React.MouseEvent, attachment: any) => {
        event.stopPropagation();
        const tab = window.open("", "_blank");
        try {
            const response = await clientNoJson(`${API_URL}${attachment.file_info.url}`, {
                responseType: "blob",
                method: "GET",
            });
            const objectUrl = window.URL.createObjectURL(response.data);
            if (tab) {
                tab.location.href = objectUrl;
                window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
            }
        } catch {
            if (tab) tab.close();
            notify("Errore nel caricamento dell'immagine", "error");
        }
    };

    return (
        <Box component="span" display="inline-flex" alignItems="center" style={{marginLeft: "10px"}}>
            {attachments.map((attachment: any) => (
                <IconButton
                    key={attachment.id}
                    size="small"
                    title={`Apri ${attachment.file_info.name}`}
                    onClick={(event) => openImage(event, attachment)}
                >
                    <ImageIcon fontSize="small" />
                </IconButton>
            ))}
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 10,
    },
    title: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
    },
    titleLeft: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    attachmentTableHeader: {
        position: "static",
    },
}));


export function ShowDeliveryAttachment({record}: { record: any }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const {data: optionsNotes} = useOptions("notes", "GET");

    const attachmentsCount = record?.deliveryattachment_set?.length || 0;

    const handleClickOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <IconButton size="small" onClick={handleClickOpen} title="Mostra allegati">
                <Badge
                    badgeContent={attachmentsCount}
                    color="primary"
                    invisible={!attachmentsCount}
                    max={99}
                >
                    <AttachFileIcon fontSize="small"/>
                </Badge>
            </IconButton>
            <DeliveryAttachmentImages record={record}/>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                classes={{paper: classes.dialogPaper}}
                onClick={(event) => event.stopPropagation()}
            >
                <DialogTitle disableTypography>
                    <Box className={classes.title}>
                        <Box className={classes.titleLeft}>
                            <AttachFileIcon color="primary"/>
                            <Box>
                                <Typography variant="h6">
                                    Allegati
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Missione #{record?.id} {record?.document_number}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent dividers>
                    <AddDeliveryAttachmentButton/>
                    {optionsNotes && <Grid item xs={12}>
                        <TableContainer>
                            <ArrayField
                                source="deliveryattachment_set"
                                record={record}
                            >
                                <Datagrid classes={{headerCell: classes.attachmentTableHeader}}>
                                    <FunctionField
                                        render={(record: any) => (
                                            <DeleteButton
                                                record={record}
                                                resource="delivery_attachments"
                                                redirect={`/deliveries`}
                                                mutationMode="pessimistic"
                                            />
                                        )}
                                    />
                                    <IdentifierField
                                        {...initField("id", optionsNotes)}
                                    />

                                    <CustomFileField
                                        {...initField("file_info", optionsNotes)}
                                        title="name"
                                        src="url"
                                    />

                                    <TextField
                                        {...initField("notes", optionsNotes)}
                                    />
                                </Datagrid>
                            </ArrayField>
                        </TableContainer>
                    </Grid>}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} label="Chiudi"/>
                </DialogActions>
            </Dialog>
        </>
    )
}
